import { TableUIProvider } from "../../contexts/TableUIContext";
import Events from "./Events";

export default function EventsWrapper() {
    return (
        <TableUIProvider>
            <Events />
        </TableUIProvider>
    );
}
